import {
  playerCol,
  teamCol,
  confCol,
  yearCol,
  divCol,
  classCol,
  btCol,
  numCol,
  round3Col,
  round1Col,
  round0Col,
  pctColWithSort,
  warCol,
  sosAdjWarCol,
  opsCol,
} from "./leaderboards/helpers";

const battingBasicStats = [
  numCol("GP", "gp"),
  numCol("GS", "gs"),
  numCol("PA", "pa"),
  numCol("AB", "ab"),
];

const battingHittingStats = [
  numCol("H", "h"),
  numCol("2B", "2b"),
  numCol("3B", "3b"),
  numCol("HR", "hr"),
  numCol("R", "r"),
  numCol("RBI", "rbi"),
];

const battingBaserunningStats = [
  numCol("SB", "sb"),
  numCol("CS", "cs"),
  pctColWithSort("SB%", "sb_pct"),
];

const battingPlateDiscipline = [
  numCol("BB", "bb"),
  numCol("HBP", "hbp"),
  numCol("Picked", "picked", "6rem"),
  numCol("SF", "sf"),
  numCol("SO", "k"),
];

const battingRates = [
  round3Col("BA", "ba", "5rem"),
  round3Col("OBP", "ob_pct", "5rem"),
  round3Col("SLG", "slg_pct", "5rem"),
  opsCol("5rem"),
  round3Col("ISO", "iso", "5rem"),
  round3Col("wOBA", "woba", "5rem"),
];

const battingAdvanced = [
  pctColWithSort("K%", "k_pct"),
  pctColWithSort("BB%", "bb_pct"),
  round3Col("BABIP", "babip", "5rem"),
  round1Col("wRC", "wrc", "6rem"),
  round0Col("wRC+", "wrc_plus", "5rem"),
  round0Col("OPS+", "ops_plus", "5rem"),
  round3Col("RC/PA", "rc_per_pa", "6rem"),
];

const battingValue = [
  round1Col("RE24", "rea", "6rem"),
  round1Col("WPA", "wpa", "6rem"),
  round1Col("WPA/LI", "wpa_li", "6rem"),
  round1Col("Clutch", "clutch", "6rem"),
];

const battingWarComponents = [
  round1Col("Batting", "batting", "6rem"),
  round1Col("Base Run", "baserunning", "6rem"),
  round1Col("Pos. Adj", "adjustment", "6rem"),
];

const battingOther = [
  round1Col("EBT", "ebt", "6rem"),
  round1Col("GDP", "gdp", "5rem"),
  numCol("GDP Opps", "gdp_opps", "7rem"),
  round1Col("wGDP", "wgdp", "6rem"),
  round1Col("wSB", "wsb", "6rem"),
  round1Col("wEBT", "webt", "6rem"),
];

export function getBattingColumns(forStatTable = false) {
  const playerColumn = forStatTable
    ? { name: "Player", selector: (row) => row.player_name, sortable: true, width: "10rem" }
    : playerCol();

  return [
    playerColumn,
    teamCol("10rem"),
    confCol(),
    divCol(),
    yearCol(),
    classCol(),
    btCol(),
    ...battingBasicStats,
    ...battingHittingStats,
    ...battingBaserunningStats,
    ...battingPlateDiscipline,
    ...battingRates,
    ...battingAdvanced,
    ...battingValue,
    ...battingWarComponents,
    warCol("5rem"),
    sosAdjWarCol("7rem"),
    ...battingOther,
  ];
}
